import { AppFlowRoute } from "../../atoms/appFlow";
import { FlowPages } from "./types";

export const getProgressStepperRoutes = (node: FlowPages): AppFlowRoute[] => {
  return node
    .filter((child) => child.props.showInProgressStepper)
    .map((node) => ({
      path: node.props.path,
      checkpoint: node.props.checkpoint,
    }));
};
